import * as React from 'react'

// eslint-disable-next-line no-unused-vars
import { ISVG } from '../interfaces/svg'

export const ThumbsUp = ({ title, titleId, ...props }: ISVG) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M14 9H13C13 9.55228 13.4477 10 14 10V9ZM14 5H15H14ZM11 2V1C10.6048 1 10.2467 1.23273 10.0862 1.59386L11 2ZM7 11L6.08619 10.5939C6.02936 10.7217 6 10.8601 6 11H7ZM7 22H6C6 22.5523 6.44772 23 7 23V22ZM18.28 22L18.2913 21H18.28V22ZM20.28 20.3L19.2916 20.1484L19.2913 20.1501L20.28 20.3ZM21.66 11.3L22.6484 11.4516L22.6487 11.4501L21.66 11.3ZM19.66 9V10.0001L19.6713 9.99994L19.66 9ZM7 22V23C7.55228 23 8 22.5523 8 22H7ZM7 11H8C8 10.4477 7.55228 10 7 10V11ZM15 9V5H13V9H15ZM15 5C15 2.79086 13.2091 1 11 1V3C12.1046 3 13 3.89543 13 5H15ZM10.0862 1.59386L6.08619 10.5939L7.91381 11.4061L11.9138 2.40614L10.0862 1.59386ZM6 11V22H8V11H6ZM7 23H18.28V21H7V23ZM18.2687 22.9999C19.7646 23.0168 21.0444 21.929 21.2687 20.4499L19.2913 20.1501C19.2165 20.6431 18.7899 21.0057 18.2913 21.0001L18.2687 22.9999ZM21.2684 20.4516L22.6484 11.4516L20.6716 11.1484L19.2916 20.1484L21.2684 20.4516ZM22.6487 11.4501C22.7808 10.5798 22.524 9.69553 21.9465 9.03134L20.4373 10.3437C20.6298 10.5651 20.7154 10.8599 20.6713 11.1499L22.6487 11.4501ZM21.9465 9.03134C21.3689 8.36714 20.5288 7.9901 19.6487 8.00006L19.6713 9.99994C19.9647 9.99661 20.2447 10.1223 20.4373 10.3437L21.9465 9.03134ZM19.66 8H14V10H19.66V8ZM7 21H4V23H7V21ZM4 21C3.44772 21 3 20.5523 3 20H1C1 21.6569 2.34315 23 4 23V21ZM3 20V13H1V20H3ZM3 13C3 12.4477 3.44772 12 4 12V10C2.34315 10 1 11.3431 1 13H3ZM4 12H7V10H4V12ZM6 11V22H8V11H6Z'
      fill='currentColor'
    />
  </svg>
)
